const PostTags = ({ tags }: { tags: string[] }) => {
  return (
     <div className="border border-gray-200 rounded-lg p-6">
        <h3 className="text-xs text-gold uppercase mb-3 font-bold">Tags</h3>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag: string) => (
            <span 
              key={tag}
              className="border border-border text-black px-3 py-1 text-sm rounded-lg"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
  );
}
 
export default PostTags;